import { useEffect } from 'react';
const useDisableBodyOverflow = (isOverflowHidden = false, dependencies = []) => {
    useEffect(() => {
        document.body.style.overflow = isOverflowHidden ? 'hidden' : 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, dependencies);
};
export default useDisableBodyOverflow;